// Smart Sash Admin Panel - Institution Service
// CRUD operations for institution management (v2 API)

import { axiosClient } from '../http/axiosClient';
import {
  InstitutionDTO,
  CreateInstitutionRequest,
  UpdateInstitutionRequest,
  PaginatedResponse,
  PaginationParams,
  ApiPaginatedData,
  toPaginatedResponse,
  EmergencyContactDTO,
} from '@/models';

const BASE_PATH = '/Institution';

/**
 * Institution Service (v2)
 */
export const institutionService = {
  /**
   * Get all institutions with pagination
   */
  getAll: async (params?: PaginationParams): Promise<PaginatedResponse<InstitutionDTO>> => {
    const response = await axiosClient.get<ApiPaginatedData<InstitutionDTO>>(BASE_PATH, {
      params,
    });
    return toPaginatedResponse(response.data);
  },

  /**
   * Get institution by ID
   */
  getById: async (id: string): Promise<InstitutionDTO> => {
    const response = await axiosClient.get<InstitutionDTO>(`${BASE_PATH}/${id}`);
    return response.data;
  },

  /**
   * Create new institution
   */
  create: async (data: CreateInstitutionRequest): Promise<InstitutionDTO> => {
    const response = await axiosClient.post<InstitutionDTO>(BASE_PATH, data);
    return response.data;
  },

  /**
   * Update existing institution
   */
  update: async (id: string, data: UpdateInstitutionRequest): Promise<InstitutionDTO> => {
    const response = await axiosClient.put<InstitutionDTO>(`${BASE_PATH}/${id}`, data);
    return response.data;
  },

  /**
   * Delete institution
   */
  delete: async (id: string): Promise<void> => {
    await axiosClient.delete(`${BASE_PATH}/${id}`);
  },

  /**
   * Get institution emergency contact
   */
  getEmergencyContact: async (id: string): Promise<EmergencyContactDTO> => {
    const response = await axiosClient.get<EmergencyContactDTO>(
      `${BASE_PATH}/${id}/emergency-contact`
    );
    return response.data;
  },

  /**
   * Update institution emergency contact
   */
  updateEmergencyContact: async (id: string, data: EmergencyContactDTO): Promise<void> => {
    await axiosClient.patch(`${BASE_PATH}/${id}/emergency-contact`, data);
  },
};

export default institutionService;
